<template>
  <div class="route-isolate"
       v-if="initialized"
       v-show="isCurrent">
    <component v-if="!onRefresh"
               :is="pageComponent"
               v-bind="pageParams"></component>
  </div>
</template>

<script>
import routeUtils from '../../../util/routeUtils'
export default {
  name: 'RouteIsolate',
  props: {
    isCurrent: Boolean,
    isRefresh: Boolean
  },
  data () {
    return {
      initialized: false,
      pageComponent: null,
      pageParams: {}
    }
  },
  computed: {
    onRefresh () {
      return this.isCurrent && this.isRefresh
    }
  },
  methods: {
    onInitialPage () {
      let routeMatch = routeUtils.getChildRouteMatch(this, this.$route)
      if (routeMatch) {
        let components = routeMatch.components
        if (components) {
          this.pageComponent = components.default
        }
      }
      this.pageParams = this.$route.params
    }
  },
  watch: {
    isCurrent: {
      handler: function (val) {
        if (val) {
          this.initialized = true
          this.$nextTick(() => this.onInitialPage())
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
  .route-isolate {
    position: relative;
    height: 100%;
  }
</style>
